module.exports = __webpack_public_path__ + "static/media/BlackEyeIcon.5157c851.svg";